import { Box, Typography } from "@mui/material";

import { CapturedError } from "@/utils/clientErrorTracking";

interface PersistentErrorContentProps {
  message: string;
  capturedError: CapturedError;
}

export const PersistentErrorContent = ({
  message,
  capturedError,
}: PersistentErrorContentProps) => (
  <Box>
    <Typography variant="body2" sx={{ mb: 0.5 }}>
      {message}
    </Typography>
    <Typography variant="caption" sx={{ fontFamily: "monospace", opacity: 0.9 }}>
      Ref: {capturedError.errorId}
    </Typography>
  </Box>
);
